import { Account } from "../../types/account";
import { Json } from "../../types/database.types";
import { logError } from "../../utils/error";
import { supabase } from "../supabase/client";

export const fetchAccount = async (tenantId: string) => {
  try {
    const { data, error } = await supabase
      .from("account")
      .select("*")
      .eq("spoke_tenant_id", tenantId)
      .single();

    if (error) {
      logError("Error fetching account", error);
      throw error;
    }

    return data as Account;
  } catch (error) {
    logError("Error in fetchAccount", error);
    throw error;
  }
};

export const updateAccount = async (account: Partial<Account> & { id: string }, tenantId: string) => {
  try {
    const { data, error } = await supabase
      .from("account")
      .update({
        name: account.name,
        description: account.description,
        protocol_list: account.protocol_list,
        enabled: account.enabled,
        email_bcc_addresses: account.email_bcc_addresses,
        email_to_users: account.email_to_users,
        email_flags: account.email_flags as Json,
        sample_rate_pct: account.sample_rate_pct,
        user_filter: account.user_filter,
        company_tone_and_language: account.company_tone_and_language,
        email_bcc_groups: account.email_bcc_groups as Json,
        modified: new Date().toISOString()
      })
      .eq("spoke_tenant_id", tenantId)
      .select()
      .single();

    if (error) {
      logError("Error updating account", error);
      throw error;
    }

    return data as Account;
  } catch (error) {
    logError("Error in updateAccount", error);
    throw error;
  }
};
